import { render } from "./Reviews.vue?vue&type=template&id=4d689dde&scoped=true"
import script from "./Reviews.vue?vue&type=script&lang=ts"
export * from "./Reviews.vue?vue&type=script&lang=ts"

import "./Reviews.vue?vue&type=style&index=0&id=4d689dde&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d689dde"

export default script